 var hostInfo = "https://carpopa.com/quizapi/"
// var hostInfo = "http://localhost:5000/quizapi/"

var coinCookieName = "coinquizpopa"

export default{ hostInfo,coinCookieName} ;
